document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-tdp-product]').forEach(function (section) {
    var optionSelects = Array.prototype.slice.call(section.querySelectorAll('[data-product-option]'));
    var variantIdInput = section.querySelector('[data-variant-id]');
    var variantDataElement = section.querySelector('[data-product-variants]');
    var price = section.querySelector('[data-price]');
    var retailRow = section.querySelector('[data-retail-row]');
    var retailPrice = section.querySelector('[data-retail-price]');
    var savings = section.querySelector('[data-dealer-savings]');
    // Read Shopify-rendered variant IDs and prices directly from HTML attributes.
    // No JSON serialization/parsing: prevents malformed JSON from hiding retail prices.
    var retailReferences = {};
    section.querySelectorAll('[data-retail-variant-id]').forEach(function (entry) {
      var id = entry.getAttribute('data-retail-variant-id');
      var cents = Number(entry.getAttribute('data-retail-cents'));
      if (id && Number.isFinite(cents) && cents > 0) retailReferences[id] = cents;
    });
    var button = section.querySelector('[data-cart-button]');
    var status = section.querySelector('[data-option-status]');
    var variants = [];
    try { if (variantDataElement) variants = JSON.parse(variantDataElement.textContent); } catch (error) { variants = []; }

    function formatPrice(cents) {
      var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
      try { return new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: currency }).format(cents / 100); }
      catch (error) { return '$' + (cents / 100).toFixed(2); }
    }

    function updateSelection() {
      var chosen = optionSelects.map(function (select) { return select.value; });
      var variant = variants.find(function (candidate) {
        return candidate.options.length === chosen.length && candidate.options.every(function (value, index) { return value === chosen[index]; });
      });
      var available = !!(variant && variant.available);
      if (variantIdInput) variantIdInput.value = variant ? String(variant.id) : '';
      if (button) {
        button.disabled = !available;
        button.textContent = !variant ? 'Combination unavailable' : available ? 'Add to cart' : 'Sold out';
      }
      if (status) {
        status.hidden = available;
        status.textContent = !variant ? 'This combination is not offered. Please choose different options.' : variant.available ? '' : 'This combination is currently unavailable.';
      }
      if (!variant) return;
      if (price) price.textContent = formatPrice(variant.price);
      if (retailRow && retailPrice && savings) {
        var reference = retailReferences[String(variant.id)];
        // On initial render Liquid already knows the current variant's reference.
        // Do not hide it when an unavailable/missing variant lookup is encountered.
        if (!(typeof reference === 'number' && reference > 0) &&
            String(variant.id) === section.getAttribute('data-initial-variant-id')) {
          reference = Number(section.getAttribute('data-initial-retail-cents')) || 0;
        }
        var hasReference = typeof reference === 'number' && isFinite(reference) && reference > 0;
        retailRow.hidden = !hasReference;
        savings.hidden = !(hasReference && reference > variant.price);
        if (hasReference) {
          retailPrice.textContent = formatPrice(reference);
          savings.textContent = reference > variant.price ? 'You save ' + formatPrice(reference - variant.price) : '';
        }
      }
      var main = section.querySelector('.tdp-gallery-main img');
      if (main && variant.featured_image && variant.featured_image.src) {
        main.src = variant.featured_image.src;
        main.removeAttribute('srcset');
        main.alt = variant.featured_image.alt || '';
      }
      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    optionSelects.forEach(function (select) { select.addEventListener('change', updateSelection); });
    if (optionSelects.length) updateSelection();

    var main = section.querySelector('.tdp-gallery-main img');
    section.querySelectorAll('.tdp-thumb').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        if (!main) return;
        main.src = thumb.dataset.imageSrc;
        main.removeAttribute('srcset');
        main.alt = thumb.dataset.imageAlt || '';
        section.querySelectorAll('.tdp-thumb').forEach(function (other) {
          other.classList.remove('is-active');
          other.setAttribute('aria-pressed', 'false');
        });
        thumb.classList.add('is-active');
        thumb.setAttribute('aria-pressed', 'true');
      });
    });
  });
});
